/* eslint-disable react/jsx-one-expression-per-line */
import React, { useContext, useEffect, useMemo } from 'react';
import axios from 'axios';
import Container from 'container';
import { context } from 'context/cart-preview';
import useGlobal from 'hooks/useGlobal';
import { useCartPage } from 'context/cart-page';
import Headline from 'headline';
import Button from 'button';
import OrderSummary from 'shared/order-summary';
import DiscountForm from 'shared/discount-form';
import SuggestedProduct from 'shared/suggested-product';
import Hero from 'components/templates-default/cohort-hero';
import useCustomerAccessToken from 'hooks/useCustomerAccessToken';
import Cart from './cart';
import CTACartBanner from './page-cart-banner';
import Header from '../header';

import s from './order-summary.module.scss';

function findSliceIndex(length, idx) {
  if (idx < length - 1) return 1;
  return 4;
}

export default function CartPage() {
  const { customerAccessToken } = useCustomerAccessToken();
  const { state, emit } = useGlobal();
  const { cart } = useContext(context);
  const cartContext = useCartPage();
  const fetchSuggestedProducts = async () => {
    const { data } = await axios.get('/product-map.json');
    cartContext.dispatch({
      type: 'callback',
      cb: prevState => ({ ...prevState, productMap: data })
    });
  };
  const suggestedProducts = useMemo(() => {
    if (!cartContext.state.productMap || !cart.cartItems) {
      return [];
    }

    const lineItems = cart.cartItems.map(
      ({ productData }) => productData[0].id
    );
    return [...lineItems]
      .sort((a, b) => {
        const { state } = cartContext;
        return (
          state.productMap[a].recommendedProducts.length -
          state.productMap[b].recommendedProducts.length
        );
      })
      .reduce((acc, curr, idx) => {
        const suggestedProductIds = acc.map(({ id }) => id);
        const suggestedProducts = cartContext.state.productMap[
          curr
        ].recommendedProducts
          .filter(product => {
            const condition =
              !suggestedProductIds.includes(product.id) &&
              !lineItems.includes(product.id);
            return condition;
          })
          .slice(
            0,
            lineItems.length === 1 ? 3 : findSliceIndex(lineItems.length, idx)
          );
        return [...acc, ...suggestedProducts];
      }, []);
  });
  useEffect(() => {
    if (cartContext.state.ready) {
      // fetchSuggestedProducts();
    }
  }, [cartContext.state.ready]);
  return (
    <main className={s.root}>
      <Hero title="Cart" />
      <Header />
      <Cart cart={cart} noNav={!cart.quantity} />
      {cart.quantity && customerAccessToken && (
        <Container className={s.cost}>
          <div className={s.costWrapper}>
            <div
              className={`${s.costChild} ${
                suggestedProducts.length > 2 ? s.blur : ''
              }`}
            >
              {suggestedProducts && suggestedProducts[0] && (
                <>
                  <Headline h5 el="p" className={s.recommendedTitle}>
                    Others also bought...
                  </Headline>
                  <div className={s.recommendedProducts}>
                    {suggestedProducts.slice(0, 4).map(props => (
                      <SuggestedProduct
                        {...props}
                        config={{ slimProduct: true, noSpin: true }}
                        key={props.id}
                        className={`${s.suggestedProduct} ${
                          suggestedProducts.length > 2 ? s.blur : ''
                        }`}
                      />
                    ))}
                  </div>
                </>
              )}
            </div>
            <div className={s.costChild}>
              <div className={s.ctaBannerWrapper}>
                <CTACartBanner />
              </div>
              <DiscountForm className={s.discountForm} />
              <OrderSummary className={s.orderSummary} />
              <NextStepButton href={cart?.checkoutUrl} />
            </div>
          </div>
        </Container>
      )}
    </main>
  );
}

function NextStepButton({ href }) {
  const { emit } = useGlobal();
  const nextStep = () =>
    emit.update({
      checkout: {
        step: 'shipping'
      }
    });
  return (
    <div className={s.checkout}>
      <Button onClick={nextStep}>Proceed to checkout</Button>
    </div>
  );
}
